import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconEnterRightOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m5.81 6.93 1.06-1.06L13 12l-6.13 6.13-1.06-1.06 4.319-4.32H-.16v-1.5H10.13zM14 3h7v18h-7zM1.5 1.5v3.75H0V1.5A1.5 1.5 0 0 1 1.5 0h21A1.5 1.5 0 0 1 24 1.5v21a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 0 22.5v-3.75h1.5v3.75h21v-21z" /></svg>
);
